var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-subs"},[_c('TextArea'),_vm._v(" "),_c('Subscribe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }